import { nameToEmoji } from "gemoji";
import remarkGemoji from "remark-gemoji";
function gemoji() {
  const remark = (processor) => processor.use(remarkGemoji);
  return {
    remark,
    mdxHandlerList: () => (input) => {
      if ("res" in input)
        return input;
      const node = input.source;
      if (node.type !== "text")
        return input;
      if (!node.value) {
        return {
          res: null
        };
      }
      node.value = node.value.replace(/:(\+1|[-\w]+):/g, function(_, $1) {
        return Object.prototype.hasOwnProperty.call(nameToEmoji, $1) ? nameToEmoji[$1] : _;
      });
      return input;
    }
  };
}
export {
  gemoji as default
};
